import { IOrderItem } from './i-order';

export interface IInventory {
  id: string;
  type: string;
  supplierId: string;
  locationId: string;
  locationName: string;
  transferId: string;
  eventType: string;
  user: IInventoryUser;
  status: string;
  comment: string;
  products: IInventorySellerProduct[];
  stockSupplierName: string;
  stockSupplierOrderNumber: string;
  orderDate: any;
  orderInvoiceNumber: string;
  expectedDeliveryDate: any;
  actualDeliveryDate: any;
  deliveryPersonName: string;
  deliveryPersonContactNumber: string;
  deliveryPersonVehicleRegistration: string;
  deliveryNoteNumber: string;
  goodsReceivedNoteNumber: string;
  createdAt: any;
  updatedAt: any;
}

export interface IInventoryUser {
  id: string;
  firstName: string;
  surname: string;
}

export interface IInventorySellerProduct {
  id: string;
  productId: string;
  product: IInventoryProduct;
  price: number;
  units: number;
  minUnits: number;
  maxUnits: number;
  comment?: string;
  pricingTier?: any;
}

export interface IInventoryProduct {
  id: string;
  name: string;
  description: string;
  barcode: string;
  images: IInventoryProductImage[];
}

export interface IInventoryProductImage {
  url: string;
  sizes: string;
  description: string;
  barcode: string;
  images: IInventoryProductImageSize[];
}

export interface IInventoryProductImageSize {
  url: string;
  height: number;
}

interface IInventoryBase {
  locationId: string;
  status: string;
  comment: string;
}

export interface IInventoryOut extends IInventoryBase {
  products: any[];
}

export interface IInventoryIn extends IInventoryBase {
  stockSupplierName: string;
  stockSupplierOrderNumber: string;
  orderDate: any;
  orderInvoiceNumber: string;
  expectedDeliveryDate: any;
  actualDeliveryDate: any;
  deliveryPersonName: string;
  deliveryPersonContactNumber: string;
  deliveryPersonVehicleRegistration: string;
  deliveryNoteNumber: string;
  goodsReceivedNoteNumber: string;
}

export interface IIndependentInventoryIn extends IInventoryIn {
  products: any[];
}

// export interface IInventoryTransferRequest {
//   inEventRequest: IInventoryIn;
//   outEventRequest: IInventoryBase;
//   products: any[];
// }
export interface IInventoryTransferOrderCreate {
  receivingLocationId: string;
  supplyingLocationId: string;
  items: IOrderItem[];
  isDirect: boolean;
  requireHandshake: boolean;
  comment: string;
  idempotencyKey?: string;
}

// TODO update this to the iorder
// export interface IInventoryTransferResponse {
//   type: string;
//   stockInEvent: IInventory;
//   stockOutEvent: IInventory;
// }

export interface IInventoryTransfer {
  originLocationId: string;
  destinationLocationId: string;
  status: string;
  comment: string;
  products: any[];
}
